import {List, Record} from 'immutable';

import BehaviorsCollection from 'web-app/behaviors/behaviors-collection';
import {type EntityModel} from 'web-app/react/entities/factory';

export interface IPermission {
    id: string;
    institutionId: string;
    body: string;
    createdAt: string;
    deletedAt: string | null;
    title: string;
    fileUrl?: string;
    filename?: string;
    recipients: List<any>;
    behaviors: BehaviorsCollection;
}

const Permission = Record<IPermission>({
    id: '',
    institutionId: '',
    body: '',
    createdAt: '',
    deletedAt: null,
    title: '',
    fileUrl: undefined,
    filename: undefined,
    recipients: List(),
    behaviors: new BehaviorsCollection([]),
});

const fromAPI = (data: any, originalPayload: any) => {
    return new Permission({
        ...data,
        id: data.permissionId,
        institutionId: originalPayload.institutionId,
        recipients: List(data.recipients),
        behaviors: new BehaviorsCollection(data.behaviors),
    });
};

const PermissionEntityModel: EntityModel<IPermission> = {
    record: Permission,
    default: new Permission(),
    fromAPI,
};

export default PermissionEntityModel;
